import normalbrowser from "../../../../assets/images/docs/normalbrowser-like.png";
import browserextension from "../../../../assets/images/docs/browserextension.png";
import * as React from 'react';
export default {
  normalbrowser,
  browserextension,
  React
};